import { render, staticRenderFns } from "./florist-create.vue?vue&type=template&id=62ec694c"
import script from "./florist-create.vue?vue&type=script&lang=js"
export * from "./florist-create.vue?vue&type=script&lang=js"
import style0 from "./florist-create.vue?vue&type=style&index=0&id=62ec694c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports